// Application constants
export const APP_VERSION = "0.2.8";
